<template>
  <div>
    <v-layout
      wrap
      justify-center
    >
      <v-flex
        xs12
        class="text-xs-center mt-5"
      >
      
        <v-icon
          size="124"
          color="primary"
        >policy</v-icon>
        <h4 class="headline mt-4 hidden-sm-and-up">Kunden-Check</h4>
      </v-flex>
      <!-- ... -->
      <v-flex
        xs12
        md8
        lg6
        grow
        class="mt-4 text-xs-center"
        v-if="this.$store.getters.authBetrieb"
      >
        <v-btn
          @click="MapsInit()"
          large
          color="primary"
          v-if="!googleloaded"
        >Kunden-Check laden</v-btn>

        <v-toolbar v-if="googleloaded">
          <v-toolbar-title class="hidden-xs-only">Kunden-Check</v-toolbar-title>
          <v-spacer class="hidden-xs-only"></v-spacer>
          <vue-google-autocomplete
            id="map"
            classname="form-control kcheckinput"
            placeholder="Nach Adresse suchen..."
            country="de"
            ref="autocomplete"
            v-on:no-results-found="noResultsFound"
            v-on:placechanged="getAddressData"
          >
          </vue-google-autocomplete>
          <v-btn
            flat
            icon
            @click="$refs.autocomplete.clear(); MeldungClear()"
          >
            <v-icon>clear</v-icon>
          </v-btn>
        </v-toolbar>
      </v-flex>
       <v-flex
        xs12
        md8
        lg6
        grow
        class="mt-4 text-xs-center "
        v-else
      >
      <strong>Nur für Premiummitglieder verfügbar, bitte lassen Sie sich verknüpfen mit Ihrem Betrieb.</strong>
       </v-flex>  
    </v-layout>

    <v-layout
      wrap
      row
      justify-center
    >

      <v-flex
        xs12
        md10
        lg8
        xl6
        class="mt-4"
        v-if="address"
      >
        <v-subheader class="mt-4">Ergebnisse</v-subheader>
        <v-sheet class="pb-4 mb-3 transparent">
          <v-layout
            row
            wrap
          >
            <v-flex
              xs12
              class="my-4 px-3 subheading"
              v-if="addressfound && !kcheckdata && !loading"
            >
              Keine Meldung zur angegebenen Adresse gefunden.
            </v-flex>
            <v-flex
              xs12
              class="mt-4 px-3 headline"
            >

              <h2
                class="title mb-4"
                v-if="addressfound && kcheckdata"
              >
                <strong>{{ kcheckdata.length }}</strong> Probleme an der Adresse gemeldet:
              </h2>
              <v-icon
                large
                left
                color="green"
                v-if="loading"
              >sick</v-icon>
              <v-icon
                large
                left
                color="green"
                v-if="addressfound && !kcheckdata && !loading"
              >check</v-icon>
              <v-icon
                large
                left
                color="red"
                v-if="addressfound && kcheckdata"
              >warning</v-icon>

              {{ StrGefunden }}
            </v-flex>

          </v-layout>
        </v-sheet>

        <v-layout
          row
          wrap
          justify-center
          v-if="kcheckdata"
        >
          <v-flex xs12 class="px-3">
              <p>Sie können jetzt nach den Namen des Geschäftspartners suchen</p>
              <v-flex
                xs12
                md8
                lg6
                grow
                class="mt-4"
                align-self-center

              >

                
                  <v-text-field
                    name="input-1"
                    label="Name des Geschäftspartners"
                    v-model="suchpartner"
                    solo
                    height="24"
                    xstyle="width: 75%;"
                  ></v-text-field>
              </v-flex>
         

            <v-container
              class="pa-0 mb-3"
              v-if="SuchpartnerFound"
            >
              <v-layout
                row
                wrap
              >
                <listing-betrieb :kcheck="SuchpartnerFound">
                </listing-betrieb>

              </v-layout>
            </v-container>
            <v-container
              class="pa-0 ma-0 mt-3"
              v-else
            >
              <v-layout
                row
                wrap
              >
                <p>Kein Eintrag zum angegebenen Nachnamen <strong>{{ suchpartner }}</strong> gefunden. Einträge werden erst gezeigt, wenn konkret nach dem Namen gesucht wird.</p>
              </v-layout>
            </v-container>
          </v-flex>

        </v-layout>
      </v-flex>

      <v-flex
        xs12
        md8
        lg6
        class="mt-5 px-3 subheading"
        v-else
      >
        <h3 class="headline">Erklärung</h3>

        <ul class="mt-3">
          <li>Überprüfen Sie <strong>Adressen</strong> darauf, ob andere dort schon schlechte Erfahrungen gemacht haben.</li>
          <li class="mt-3">Wird unter einer Adresse ein Eintrag gefunden, haben Sie die Möglichkeit, nach dem konkreten <strong>Namen</strong> zu suchen, um Details anzuzeigen.</li>
          <li class="mt-3">Tragen Sie Probleme ein und <strong>warnen Sie Ihre Innungskollegen!</strong></li>

        </ul>
      </v-flex>
    </v-layout>
    <v-layout
      row
      wrap
      justify-center
    >
      <v-flex
        xs12
        class="mb-4 px-3 text-xs-center"
        v-if="addressfound"
      >
        <v-menu transition="slide-x-transition">
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              large
            >
              <span v-if="meldung.typ == ''">
                <v-icon left>add</v-icon> Ihre Erfahrung <span class="hidden-xs-only">an der Adresse</span> mitteilen
              </span>
              <span v-if="meldung.typ == 'Positiv'">
                <v-icon
                  color="green"
                  class="mr-3"
                >circle</v-icon> Positive Erfahrungen melden
              </span>
              <span v-if="meldung.typ == 'Neutral'">
                <v-icon
                  color="yellow"
                  class="mr-3"
                >circle</v-icon> Neutrale Erfahrung melden
              </span>
              <span v-if="meldung.typ == 'Negativ'">
                <v-icon
                  color="red"
                  class="mr-3"
                >circle</v-icon> Negative Erfahrungen melden
              </span>

            </v-btn>
          </template>
          <v-list>
            <v-list-tile @click="ProblemMeldenStep('Positiv')">
              <v-list-tile-action>
                <v-icon color="green">circle</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Positiv</v-list-tile-title>

            </v-list-tile>
            <v-list-tile @click="ProblemMeldenStep('Neutral')">
              <v-list-tile-action>
                <v-icon color="yellow">circle</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Neutral</v-list-tile-title>

            </v-list-tile>
            <v-list-tile @click="ProblemMeldenStep('Negativ')">
              <v-list-tile-action>
                <v-icon color="red">circle</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Negativ</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-flex
          xs12
          class="my-3 px-3 text-xs-left"
          v-if="addressfound && this.step == 2"
        >
          <v-layout
            row
            wrap
          >
            <v-flex
              xs12
              md10
              offset-md1
              lg8
              offset-lg2
            >
              <v-text-field
                name="input-1"
                label="Name des Geschäftspartners"
                v-model="meldung.name"
              ></v-text-field>
            </v-flex>

            <v-flex
              xs12
              md10
              offset-md1
              lg8
              offset-lg2
            >
              <v-textarea
                name="input-2"
                label="Bitte begründen sie kurz Ihre Bewertung"
                v-model="meldung.nachricht"
              ></v-textarea>

            </v-flex>

            <v-flex
              xs12
              md10
              offset-md1
              lg8
              offset-lg2
            >
              <v-checkbox
                v-model="meldung.datenschutz"
                label="Ich akzeptiere die Datenschutzbestimmungen"
              ></v-checkbox>

            </v-flex>

            <v-flex
              xs12
              md10
              offset-md1
              lg8
              offset-lg2
            >
              <v-btn
                class="success"
                large
                flat
                @click="ProblemMelden()"
              >Absenden</v-btn>

            </v-flex>

          </v-layout>

        </v-flex>
        <!-- <v-btn @click="kCheck()">
              <v-icon left>search</v-icon> Check
            </v-btn> -->
      </v-flex>
    </v-layout>


    <v-layout
      row
      wrap
      justify-center
      v-if="LatestChecks"
    >
      <v-flex
        xs12
        md8
        lg6
        class="mt-5 px-3 subheading"
        v-if="LatestChecks.length > 0"

      >
        <h3 class="headline">Von Ihnen eingetragen:</h3>
        <!-- <ul>
          <li
            class="my-2"
            v-for="check in LatestChecks"
            :key="check.id"
          >
            <strong>{{ check.problem }} bei {{ check.adresse }}</strong>
            <timeago :datetime="check.updated_at"></timeago>
          </li>
        </ul> -->
        <v-card class="mt-2 mb-4">
         <v-list two-line>
          <v-list-tile
            v-for="check in LatestChecks"
            :key="check.id"
            avatar
          >
            <v-list-tile-avatar>
              <v-icon>circle</v-icon>
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title>{{ check.problem }} - {{ check.name }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ check.adresse }}</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn icon ripple>
                <v-icon color="red lighten-1">delete</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
         </v-list>
         </v-card>
      </v-flex>

    </v-layout>
  </div>
</template>

<script>
import axios from 'axios'
import ListingBetrieb from '~/components/kcheck/KcheckListingBetrieb.vue'

import VueGoogleAutocomplete from 'vue-google-autocomplete'

export default {
  components: {
    // AnfrageVerstecken
    // AnfragenListe,
    ListingBetrieb,
    VueGoogleAutocomplete
  },
  data () {
    return {
      loading: true,
      items: [],
      selected: null,
      search: '',
      select: 'ChIJSQDyt6vCuEcRe7LLOvoZxEM',
      result: null,
      address: '',
      placeresult: '',
      formattedResult: null,
      formatted_address: null,
      addressfound: false,
      kcheckdata: null,
      LatestChecks: [],
      getfields: ['adr_address', 'place_id'],
      googleloaded: false,
      apiKey: 'AIzaSyCe2zH-p6qUU4FDJpHz7hDOYqCkXv8Qj78',
      step: '1',
      suchpartner: '',
      meldung: {
        typ: '',
        name: '',
        nachricht: '',
        datenschutz: '',
        problem: '',
        ampel: ''
      }
    }
  },
  computed: {
    StrGefunden: function () {
      if (this.placeresult) {
        if (
          this.placeresult.types.includes('premise') ||
          this.placeresult.types.includes('street_address')
        ) {
          this.kCheck()
          this.addressfound = true
          this.loading = false
          return this.placeresult.formatted_address
        } else {
          this.addressfound = false
          return 'Bitte nach Straße und Hausnummer suchen und dann auswählen.'
        }
      } else {
        this.addressfound = false
        return ''
      }
    },
    SuchpartnerFound: function () {
      if (this.kcheckdata) {
        return this.kcheckdata.find(
          (x) => x.name.toUpperCase() === this.suchpartner.toUpperCase()
        )
      } else return false
    }
  },
  mounted () {
    this.getLatestChecks()
  },
  metaInfo () {
    return {
      script: [
        {
          src: `https://maps.googleapis.com/maps/api/js?key=AIzaSyCe2zH-p6qUU4FDJpHz7hDOYqCkXv8Qj78&libraries=places`,
          async: true,
          defer: true,
          callback: () => this.MapsInit()
        }
      ]
    }
  },

  methods: {
    MapsInit () {
      this.service = new window.google.maps.places.AutocompleteService()
      this.googleloaded = true
    },
    getAddressData: function (addressData, placeResultData, id) {
      this.kcheckdata = null
      this.address = addressData
      this.placeresult = placeResultData
    },
    noResultsFound () {
      this.$store.dispatch('responseMessage', {
        type: 'info',
        title: 'Place not found',
        text: 'Bitte Straße mit Hausnummer auswählen'
      })
    },
    MeldungClear () {
      this.step = '1'
      this.meldung.typ = ''
      this.meldung.name = ''
      this.meldung.nachricht = ''
      this.address = ''
      this.placeresult = ''
      this.addressfound = false
      this.addressData = ''
      this.meldung.ampel = ''
    },
    ProblemMeldenStep (val) {
      this.meldung.typ = val
      this.step = 2
    },
    ProblemMelden (val) {
      this.loading = true
      const app = this
      switch (this.meldung.typ) {
        case 'Gute Erfahrungen':
          this.meldung.ampel = 0
          break
        case 'Leichte Probleme':
          this.meldung.ampel = 1
          break
        case 'Keine Guten Erfahrungen':
          this.meldung.ampel = 2
          break
        default:
          this.meldung.ampel = 2
      }
      const daten = {
        place: this.placeresult,
        name: this.meldung.name,
        data: this.meldung.nachricht,
        problem: this.meldung.typ,
        ampel: this.meldung.ampel
      }

      axios
        .post('/api/v1/kchecks', daten)
        .then((resp) => {
          this.$store.dispatch('responseMessage', {
            type: 'success',
            title: 'Meldung gesendet',
            text: 'Problem gemeldet, Vielen Dank!'
          })
          this.kCheck()
          this.getLatestChecks()
          this.MeldungClear()
          app.loading = false
          // this.block = true
        })
        .catch((resp) => {
          //   console.log(resp);
          app.loading = false
        })
      this.loading = false
    },
    async kCheck () {
      const app = this
      this.loading = true
      this.step = 0
      if (app.placeresult.place_id) {
        try {
          // console.log(app.placeresult.place_id)
          const response = await axios.get(
            '/api/v1/kchecks/' + app.placeresult.place_id
          )
          app.kcheckdata = response.data
          // console.log(response.data)
          app.loading = false
        } catch (error) {
          app.kcheckdata = null
          app.loading = false
          console.error(error)
        }
      }
    },
    async getLatestChecks () {
      const app = this
      this.loading = true
      try {
        const response = await axios.get('/api/v1/kchecks/')
        app.LatestChecks = response.data
        app.loading = false
      } catch (error) {
        app.LatestChecks = null
      }
    }
  }
}
</script>
<style>
.kcheckinput {
  -moz-appearance: none;
  -webkit-appearance: none;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: none;
  border-radius: 3px;
  box-shadow: none;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 1rem;
  height: 2.285em;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  line-height: 1.5;
  padding-left: 0.75em;
  padding-right: 0.75em;
  position: relative;
  vertical-align: top;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  color: #363636;
  box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  max-width: 100%;
  width: 75%;
}
</style>